import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  joinToString1cxrrlmo0chqs as joinToString,
  lastOrNull1aq5oz189qoe1 as lastOrNull,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { EmptySerializersModule991ju6pz9b79 as EmptySerializersModule } from '../modules/SerializersModuleBuilders.mjs';
import { SerializationExceptioneqrdve3ts2n9 as SerializationException } from '../SerializationExceptions.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import {
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Char19o2r8palgjof as Char } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  decodeSerializableElement$default1kkisaow5bg5n as decodeSerializableElement$default,
  decodeSerializableValue3h7ajfesxzjda as decodeSerializableValue,
  decodeSequentially27kmi8jnnsnbc as decodeSequentially,
  decodeCollectionSize3l4gjp9ef5h8u as decodeCollectionSize,
  Decoder23nde051s631g as Decoder,
  CompositeDecoder2tzm7wpwkr0og as CompositeDecoder,
} from '../encoding/Decoding.mjs';
import { get_lastIndex1yw0x4k50k51w as get_lastIndex } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var NamedValueDecoderClass;
function NamedValueDecoder() {
  if (NamedValueDecoderClass === VOID) {
    class $ extends TaggedDecoder() {
      m25(_this__u8e3s4, index) {
        return this.o25(this.n25(_this__u8e3s4, index));
      }
      o25(nestedName) {
        var tmp0_elvis_lhs = this.r25();
        return this.s25(tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs, nestedName);
      }
      n25(descriptor, index) {
        return descriptor.m1p(index);
      }
      s25(parentName, childName) {
        var tmp;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(parentName) === 0) {
          tmp = childName;
        } else {
          tmp = parentName + '.' + childName;
        }
        return tmp;
      }
      t25() {
        return this.p25_1.n1() ? '$' : joinToString(this.p25_1, '.', '$.');
      }
    }
    initMetadataForClass($, 'NamedValueDecoder');
    NamedValueDecoderClass = $;
  }
  return NamedValueDecoderClass;
}
function tagBlock($this, tag, block) {
  $this.h26(tag);
  var r = block();
  if (!$this.q25_1) {
    $this.i26();
  }
  $this.q25_1 = false;
  return r;
}
var TaggedDecoderClass;
function TaggedDecoder() {
  if (TaggedDecoderClass === VOID) {
    class $ {
      constructor() {
        var tmp = this;
        // Inline function 'kotlin.collections.arrayListOf' call
        tmp.p25_1 = ArrayList().p2();
        this.q25_1 = false;
      }
      s1r() {
        return EmptySerializersModule();
      }
      u25(tag) {
        throw SerializationException().h1o(toString(getKClassFromExpression(this)) + " can't retrieve untyped values");
      }
      v25(tag) {
        return true;
      }
      w25(tag) {
        var tmp = this.u25(tag);
        return typeof tmp === 'boolean' ? tmp : THROW_CCE();
      }
      x25(tag) {
        var tmp = this.u25(tag);
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      y25(tag) {
        var tmp = this.u25(tag);
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      z25(tag) {
        var tmp = this.u25(tag);
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      a26(tag) {
        var tmp = this.u25(tag);
        return typeof tmp === 'bigint' ? tmp : THROW_CCE();
      }
      b26(tag) {
        var tmp = this.u25(tag);
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      c26(tag) {
        var tmp = this.u25(tag);
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      d26(tag) {
        var tmp = this.u25(tag);
        return tmp instanceof Char() ? tmp.e4_1 : THROW_CCE();
      }
      e26(tag) {
        var tmp = this.u25(tag);
        return typeof tmp === 'string' ? tmp : THROW_CCE();
      }
      f26(tag, enumDescriptor) {
        var tmp = this.u25(tag);
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      g26(tag, inlineDescriptor) {
        // Inline function 'kotlin.apply' call
        this.h26(tag);
        return this;
      }
      b1r(deserializer, previousValue) {
        return this.c1r(deserializer);
      }
      a1r(descriptor) {
        return this.g26(this.i26(), descriptor);
      }
      o1q() {
        var tmp0_elvis_lhs = this.r25();
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return false;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var currentTag = tmp;
        return this.v25(currentTag);
      }
      p1q() {
        return null;
      }
      q1q() {
        return this.w25(this.i26());
      }
      r1q() {
        return this.x25(this.i26());
      }
      s1q() {
        return this.y25(this.i26());
      }
      t1q() {
        return this.z25(this.i26());
      }
      u1q() {
        return this.a26(this.i26());
      }
      v1q() {
        return this.b26(this.i26());
      }
      w1q() {
        return this.c26(this.i26());
      }
      x1q() {
        return this.d26(this.i26());
      }
      y1q() {
        return this.e26(this.i26());
      }
      z1q(enumDescriptor) {
        return this.f26(this.i26(), enumDescriptor);
      }
      d1r(descriptor) {
        return this;
      }
      e1r(descriptor) {
      }
      f1r(descriptor, index) {
        return this.w25(this.m25(descriptor, index));
      }
      g1r(descriptor, index) {
        return this.x25(this.m25(descriptor, index));
      }
      h1r(descriptor, index) {
        return this.y25(this.m25(descriptor, index));
      }
      i1r(descriptor, index) {
        return this.z25(this.m25(descriptor, index));
      }
      j1r(descriptor, index) {
        return this.a26(this.m25(descriptor, index));
      }
      k1r(descriptor, index) {
        return this.b26(this.m25(descriptor, index));
      }
      l1r(descriptor, index) {
        return this.c26(this.m25(descriptor, index));
      }
      m1r(descriptor, index) {
        return this.d26(this.m25(descriptor, index));
      }
      n1r(descriptor, index) {
        return this.e26(this.m25(descriptor, index));
      }
      o1r(descriptor, index) {
        return this.g26(this.m25(descriptor, index), descriptor.p1p(index));
      }
      p1r(descriptor, index, deserializer, previousValue) {
        var tmp = this.m25(descriptor, index);
        return tagBlock(this, tmp, () => this.b1r(deserializer, previousValue));
      }
      r1r(descriptor, index, deserializer, previousValue) {
        var tmp = this.m25(descriptor, index);
        return tagBlock(this, tmp, () => {
          // Inline function 'kotlinx.serialization.encoding.decodeIfNullable' call
          var isNullabilitySupported = deserializer.m1m().b1p();
          var tmp;
          if (isNullabilitySupported || this.o1q()) {
            tmp = this.b1r(deserializer, previousValue);
          } else {
            tmp = this.p1q();
          }
          return tmp;
        });
      }
      r25() {
        return lastOrNull(this.p25_1);
      }
      h26(name) {
        this.p25_1.i2(name);
      }
      i26() {
        var r = this.p25_1.c5(get_lastIndex(this.p25_1));
        this.q25_1 = true;
        return r;
      }
    }
    protoOf($).q1r = decodeSerializableElement$default;
    protoOf($).c1r = decodeSerializableValue;
    protoOf($).t1r = decodeSequentially;
    protoOf($).v1r = decodeCollectionSize;
    initMetadataForClass($, 'TaggedDecoder', VOID, VOID, [Decoder(), CompositeDecoder()]);
    TaggedDecoderClass = $;
  }
  return TaggedDecoderClass;
}
//region block: exports
export {
  NamedValueDecoder as NamedValueDecoderzk26ztf92xbq,
};
//endregion

//# sourceMappingURL=Tagged.mjs.map
